<template>
  <div class="bg-white p-t-05 p-b-5">
    <van-tag
      v-for="(item, i) in classTypeList"
      :key="i"
      :type="item.id == activeId ? 'warning' : 'success'"
      :class="{'classTagActive':item.id != activeId}"
      class="m-l-045 classTag"
      @click="changeClassType(item)"
      >{{ item.text }}</van-tag
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      classTypeList: [
        { id: 1, text: "公开课" },
        { id: 2, text: "精品课" },
        { id: 3, text: "资料" },
      ],
      activeId:1
    };
  },
  methods:{
    changeClassType(item){
      if(item.id != this.activeId)
      this.activeId = item.id
      this.$emit("editActive",this.activeId)
    }
  },
  // watch:{
  //   activeId:{
  //     deep:true,
  //     immediate:true,
  //     handler(val) {
  //       this.$parent.active = val
  //     }
  //   }
  // }
};
</script>

<style lang="less" scoped>
.classTag {
  font-size: 14px;
  height: 24px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 12px;
}
.classTagActive {
  background: white;
  color: #636161;
}
</style>